import React from 'react';
import { Link } from 'react-router-dom';
import { useCookieConsent } from '../contexts/CookieConsentContext';
import { publicUrl } from '../utils/publicUrl';

const T12Footer = () => {
  const year = new Date().getFullYear();
  const { openSettings } = useCookieConsent();

  return (
    <footer className="site-footer">
      <div className="site-footer-inner">
        <div className="site-footer-brand">
          <img src={publicUrl('/assets/t12_logo.svg')} alt="" className="h-7 w-auto opacity-80" />
          <span>Tippspiel</span>
        </div>
        <nav className="site-footer-legal" aria-label="Rechtliches">
          <a
            href="https://tivoli12.at/impressum"
            target="_blank"
            rel="noopener noreferrer"
            className="site-footer-link"
          >
            Impressum
          </a>
          <Link to="/datenschutz" className="site-footer-link">Datenschutz</Link>
          <Link to="/teilnahmebedingungen" className="site-footer-link">Teilnahmebedingungen</Link>
          <Link to="/cookie-richtlinien" className="site-footer-link">Cookies</Link>
          <button type="button" className="site-footer-link site-footer-link--btn" onClick={openSettings}>
            Cookie-Einstellungen
          </button>
        </nav>
        <div className="site-footer-links">
          <a href="https://tivoli12.at" target="_blank" rel="noopener noreferrer" className="site-footer-link">
            tivoli12.at
          </a>
          <span className="site-footer-dot" aria-hidden>·</span>
          <span className="site-footer-copy">© {year}</span>
        </div>
      </div>
    </footer>
  );
};

export default T12Footer;
